import {autoRegister} from "../container";
import {GLOBAL} from "./globals";

export class MetadataProperties extends Map<string, string> {

    public constructor(private prefix: string) {
        super();
        this.readProperties();
    }

    private readProperties(): void {
        GLOBAL.headElement().querySelectorAll("meta").forEach(meta => {
            const property = meta.getAttribute("property") || meta.getAttribute("name");
            const value = meta.getAttribute("content");
            if (property?.startsWith(this.prefix) && !!value) {
                const key = property?.slice(this.prefix.length);
                this.set(key, value);
            }
        });
    }
}

@autoRegister()
export class Configuration extends MetadataProperties {
    public constructor() {
        super("eop-config:");
    }
}

@autoRegister()
export class Properties extends MetadataProperties {
    public constructor() {
        super("eop:");
    }
}